/* eslint-disable react/no-array-index-key */

import React from 'react';
import _ from 'lodash';
import HeadlineBreadcrumb from './HeadlineBreadcrumb';

/* eslint-disable react/no-array-index-key */
export default function ({ children }) {
  try {
    if (typeof children === 'string') {
      return (
        <div>
          <div>{children}</div>
        </div>
      );
    }
    const list = Array.from(children);
    const name = list.pop();

    /* eslint-disable react/no-array-index-key */
    const nodes = list.reduce((memo, item, index) => {
      let cell;
      if (typeof item === 'string') {
        cell = <HeadlineBreadcrumb.Cell key={index}>{item}</HeadlineBreadcrumb.Cell>;
      } else {
        cell = (
          <HeadlineBreadcrumb.Cell
            key={index}
          ><a onClick={item.onClick || null}>{_.get(item, 'text', '--')}</a>
          </HeadlineBreadcrumb.Cell>
        );
      }

      return [...memo, cell, (
        <HeadlineBreadcrumb.CellSeperator key={`${index}-divider`}>
      /
        </HeadlineBreadcrumb.CellSeperator>
      )];
    }, []);

    return (
      <HeadlineBreadcrumb>
        <HeadlineBreadcrumb.CellFinal>{name}</HeadlineBreadcrumb.CellFinal>
      </HeadlineBreadcrumb>
    );
  } catch (err) {
    console.log('error:', err);
    return `--- error: ${err.message} --`;
  }
}
// taken from HeadlineBreadcrumb to remove breadcrumb <HeadlineBreadcrumb.List> {nodes}</HeadlineBreadcrumb.List>
